// src/pages/wartungsprotokoll/WartungsprotokollSeite12.jsx

import React from "react";
import { Box } from "@chakra-ui/react";

export default function WartungsprotokollSeite12({ form, setForm }) {

  if (!form || !form.empfehlungen) return null;


  const updateRow = (index, field, value) => {
    setForm(prev => {
      const updated = [...prev.empfehlungen];
      updated[index][field] = value;
      return { ...prev, empfehlungen: updated };
    });
  };

  return (
    <Box p={8} bg="white" borderRadius="xl" boxShadow="md" mt={3} mb={3}>
    <div className="p-6 text-sm">
      <h2 style={{ fontWeight: "bold" }}>Empfehlungen</h2>

      <table className="w-full text-xs" style={{ borderCollapse: "collapse" }}>
        <thead>
          <tr>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "10%" }}>zu Nr.</th>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "45%" }}>Empfehlung</th>

            <th style={{ border: "1px solid #ccc", padding: "4px", width: "5%" }}>Sicherheit</th>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "5%" }}>Ertrag</th>
            <th style={{ border: "1px solid #ccc", padding: "4px", width: "5%" }}>Erhaltung</th>

            <th style={{ border: "1px solid #ccc", padding: "4px", width: "30%" }}>
              Kostenschätzung (Zeit / Material)
            </th>
          </tr>
        </thead>

        <tbody>
          {form.empfehlungen.map((row, idx) => (
            <tr key={idx}>
              
              {/* zu Nr */}
              <td style={{ border: "1px solid #ccc", padding: "4px" }}>
                <input
                  type="text"
                  value={row.zunr}
                  onChange={e => updateRow(idx, "zunr", e.target.value)}
                  style={{ width: "100%", border: "none", backgroundColor: "#f7f7fb" }}
                />
              </td>

              {/* Empfehlung */}
              <td style={{ border: "1px solid #ccc", padding: "4px" }}>
                <input
                  type="text"
                  value={row.empfehlung}
                  onChange={e => updateRow(idx, "empfehlung", e.target.value)}
                  style={{ width: "100%", border: "none", backgroundColor: "#f7f7fb" }}
                />
              </td>

              {/* Sicherheit */}
              <td style={{ border: "1px solid #ccc", padding: "4px", textAlign: "center" }}>
                <input
                  type="checkbox"
                  checked={row.sicherheit}
                  onChange={() => updateRow(idx, "sicherheit", !row.sicherheit)}
                />
              </td>

              {/* Ertrag */}
              <td style={{ border: "1px solid #ccc", padding: "4px", textAlign: "center" }}>
                <input
                  type="checkbox"
                  checked={row.ertrag}
                  onChange={() => updateRow(idx, "ertrag", !row.ertrag)}
                />
              </td>

              {/* Erhaltung */}
              <td style={{ border: "1px solid #ccc", padding: "4px", textAlign: "center" }}>
                <input
                  type="checkbox"
                  checked={row.erhaltung}
                  onChange={() => updateRow(idx, "erhaltung", !row.erhaltung)}
                />
              </td>

              {/* Kostenschätzung */}
              <td style={{ border: "1px solid #ccc", padding: "4px" }}>
                <input
                  type="text"
                  value={row.kosten}
                  onChange={e => updateRow(idx, "kosten", e.target.value)}
                  style={{ width: "100%", border: "none", backgroundColor: "#f7f7fb" }}
                />
              </td>

            </tr>
          ))}
        </tbody>
      </table>
    </div>
    </Box>
  );
}